<template>
  <c-menu theme="dark" :activeIndex="$route.path" @select="onSelect">
    <c-menu-heading label="" />
    <!--<c-menu-item index="/secure/dashboard" icon="icon-compass2" label="Dashboard" />-->
    <c-menu-item index="/secure/achievements/list" icon="icon-archery" label="Achievements" />
    <c-menu-item index="/secure/competitions/list" icon="icon-gamepad" label="Competitions" />
    <c-menu-item index="/secure/members/list" icon="icon-users" label="Members" />
    <c-menu-item index="/secure/settings" icon="icon-cogs" label="Settings" />
    <c-menu-divider />
  </c-menu>
</template>

<script>
export default {
  name: 'Navigation',
  methods: {
    onSelect(index) {
      this.$router.push(index);
    }
  }
};
</script>
